import { t } from "i18next";

import { useGetBasicStyling } from "@/requests/hooks/comply";

import Shimmer from "@/components/Shimmer";
import ComponentError from "@/components/ComponentError";
import { ThemeForm } from "@/components/Form";

const Theme = () => {
  const {
    data: basicStylingData,
    isLoading: isBasicStylingLoading,
    isError: isBasicStylingError,
  } = useGetBasicStyling();

  const renderLoading = () => <Shimmer />;

  if (isBasicStylingLoading) return renderLoading();

  if (isBasicStylingError)
    return <ComponentError message={t("comply.privacyCenter.theme.error")} />;

  if (!basicStylingData)
    return (
      <ComponentError message={t("comply.privacyCenter.theme.dataError")} />
    );

  return <ThemeForm basicStylingData={basicStylingData} />;
};

export default Theme;
